// import React, { useState } from "react";
// //import "../UsefulComponent/moreOptionButton.css";
// import translations from '../../utils/language/translations.json'
// import { useTranslation } from 'react-i18next';
// import zIndex from "@mui/material/styles/zIndex";
// import { preventDefault } from "@fullcalendar/core/internal.js";
// function MoreOptionsButton({
//   isOwner,
//   onMarkAsSoldClick,
//   onEditClick,
//   onDeleteClick,
//   onRemoveFromWatchlistClick,
//   onMylisting,
//   collectionList,
//   onAssignCollection,
//   cardId,
//   isForSale,
//   isForTrade,
//   isPC,
//   isOnEbay,
//   onRemoveFromSellCards,
//   onRemoveFromTradeCards,
//   onRemoveFromPC,
//   onRemoveFromEbay,
// }) {
 
  
//   const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
//   const currentLang = i18n.language; // Access the current language
//   const t = (key) => translations.CardGrid[key][currentLang]; // Adjust the path according to your JSON structure
 
//   const [showOptions, setShowOptions] = useState(false);
//   const mylisting = onMylisting;
//   const [showCollectionToAssign, setShowCollectionToAssign] = useState(false);
//   //console.log('mylisting ',mylisting)
//   console.log('isowner',isOwner)
//   const toggleOptions = (event) => {
//     event.preventDefault()
//     event.stopPropagation(); // ✅ Stop event bubbling here
//     setShowOptions(!showOptions);
//   };

//   const handleOptionClick = (callback) => {
//     if (typeof callback === "function") {
//       callback();
//     } else {
//       console.error("Callback is not a function:", callback);
//     }
//     setShowOptions(false);
//   };

 
//   const dropdownarrow = ()=>{
//     return (   <div style={{align:"right"}}><svg fill="#fafafa" height="30px" width="30px" viewBox="0 0 512 512" onClick={(e)=>toggleOptions(e)} style={{cursor: 'pointer'}}>
//     <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
//     <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
//     <g id="SVGRepo_iconCarrier">
//       <g>
//         <g>
//           <path d="M256,0C114.837,0,0,114.837,0,256s114.837,256,256,256s256-114.837,256-256S397.163,0,256,0z M377.749,228.416 L271.083,335.083c-4.16,4.16-9.621,6.251-15.083,6.251c-5.462,0-10.923-2.091-15.083-6.251L134.251,228.416 c-8.341-8.341-8.341-21.824,0-30.165s21.824-8.341,30.165,0L256,289.835l91.584-91.584c8.341-8.341,21.824-8.341,30.165,0 C386.091,206.592,386.091,220.075,377.749,228.416z"></path>
//         </g>
//       </g>
//     </g>
//   </svg></div>)
//   }

//   const moreOptionicon = ()=>{
//     return(
// <svg fill="#ffffff" width="18px" height="18px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff" onClick={toggleOptions} style={{cursor: 'pointer'}} ><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M388.8 896.4v-27.198c.6-2.2 1.6-4.2 2-6.4 8.8-57.2 56.4-102.4 112.199-106.2 62.4-4.4 115.2 31.199 132.4 89.199 2.2 7.6 3.8 15.6 5.8 23.4v27.2c-.6 1.8-1.6 3.399-1.8 5.399-8.6 52.8-46.6 93-98.6 104.4-4 .8-8 2-12 3h-27.2c-1.8-.6-3.6-1.6-5.4-1.8-52-8.4-91.599-45.4-103.6-96.8-1.2-5-2.6-9.6-3.8-14.2zm252.4-768.797l-.001 27.202c-.6 2.2-1.6 4.2-1.8 6.4-9 57.6-56.8 102.6-113.2 106.2-62.2 4-114.8-32-131.8-90.2-2.2-7.401-3.8-15-5.6-22.401v-27.2c.6-1.8 1.6-3.4 2-5.2 9.6-52 39.8-86 90.2-102.2 6.6-2.2 13.6-3.4 20.4-5.2h27.2c1.8.6 3.6 1.6 5.4 1.8 52.2 8.6 91.6 45.4 103.6 96.8 1.201 4.8 2.401 9.4 3.601 13.999zm-.001 370.801v27.2c-.6 2.2-1.6 4.2-2 6.4-9 57.4-58.6 103.6-114.6 106-63 2.8-116.4-35.2-131.4-93.8-1.6-6.2-3-12.4-4.4-18.6v-27.2c.6-2.2 1.6-4.2 2-6.4 8.8-57.4 58.6-103.601 114.6-106.2 63-3 116.4 35.2 131.4 93.8 1.6 6.4 3 12.6 4.4 18.8z"></path></g></svg>
//   )}

//   return (
//     <div>
//    {/* {//dropdownarrow()
//     moreOptionicon()
//     } */}
//     {dropdownarrow()}
    
//       {showOptions && (
//         <div className="options-dropdown" style={{zIndex:'999999'}}>
//           <ul>
//             <li onClick={() => setShowOptions(false)} style={{ fontWeight: "bold", color: "#ff6666" }}>
//   ❌ {t('Close')}
// </li>
//             {!showCollectionToAssign && isOwner ? (
//               <>
//                 <li onClick={() => handleOptionClick(onEditClick)}>
//                   {t('Edit the card')}
//                 </li>
              
                
//                 <li onClick={() => setShowCollectionToAssign(true)}>
//                 {t('Assign To collection')}{" "}
//                 </li>
               
//                 <li onClick={() => handleOptionClick(onMarkAsSoldClick)}>
//                   {t("Mark as Sold & Set Price")}
//                 </li>


// {isForSale ? (
//                   <li
//                     onClick={() =>
//                       handleOptionClick(onRemoveFromSellCards)
//                     }
//                   >
//                     {t('Not For Sale')}
//                   </li>
//                 ) : null}
                
//                 {isForTrade ? (
//                   <li
//                     onClick={() =>
//                       handleOptionClick(onRemoveFromTradeCards)
//                     }
//                   >
//                     {t('Not For Trade')}
//                   </li>
//                 ) : null}
//                 {isPC ? (
//                   <li
//                     onClick={() =>
//                       handleOptionClick(onRemoveFromPC)
//                     }
//                   >
//                     {t('Not PC')}
//                   </li>
//                 ) : null}
//                 {isOnEbay ? (
//                   <li
//                     onClick={() =>
//                       handleOptionClick(onRemoveFromEbay)
//                     }
//                   >
//                     {t('Not On Ebay')}
//                   </li>
//                 ) : null}
                
//                 {mylisting !== "" && mylisting !== "0" && mylisting !== "MyListings"? (
//                   <li
//                     onClick={() =>
//                       handleOptionClick(onRemoveFromWatchlistClick)
//                     }
//                   >
//                     {" "}
//                     {t('Remove from watchlist')} ({mylisting}){" "}
//                   </li>
//                 ) : null}
//                 <li onClick={() => handleOptionClick(onDeleteClick)}>
//                 {t('Delete the card')} 
//                 </li>
//               </>
//             ) : (
//               <>
//                 <li onClick={() => setShowCollectionToAssign(false)}>{t('Cancel')}</li>
//                 {collectionList.map((collection) => (
//                  <li
//                  key={collection.ListId}
//                  value={collection.ListId}
//                  onClick={() => handleOptionClick(() => onAssignCollection(collection.ListId, cardId))}
//                >
//                     {`${t('Add to')} ${collection.Title} (${collection.collectionCount})`}
//                   </li>
//                 ))}
//               </>
//             )}
//           </ul>
//         </div>
//       )}
//     </div>
//   );
// }

// export default MoreOptionsButton;

import React, { useEffect, useRef, useState } from "react";
import translations from "../../utils/language/translations.json";
import { useTranslation } from "react-i18next";

function MoreOptionsButton({
  isOwner,
  onMarkAsSoldClick,
  onEditClick,
  onDeleteClick,
  onRemoveFromWatchlistClick,
  onMylisting,
  collectionList = [],
  onAssignCollection,
  cardId,
  isForSale,
  isForTrade,
  isPC,
  isOnEbay,
  onRemoveFromSellCards,
  onRemoveFromTradeCards,
  onRemoveFromPC,
  onRemoveFromEbay,
  /** Optional: inform parent to set/unset blur/overlay */
  onOpenChange,
}) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.CardGrid[key][currentLang];

  const [open, setOpen] = useState(false);
  const [assigning, setAssigning] = useState(false);
  const rootRef = useRef(null);

  // Close on outside click / ESC
  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (!rootRef.current?.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("pointerdown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("pointerdown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  // Inform parent (to toggle blur)
  useEffect(() => {
    onOpenChange?.(open);
  }, [open, onOpenChange]);

  const handleOption = (fn) => {
    if (typeof fn === "function") fn();
    setOpen(false);
    setAssigning(false);
  };

  return (
    <div
      className="kebab-root"
      ref={rootRef}
      onClick={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
    >
      {/* kebab button */}
      <button
        className="kebab"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        title="More"
      >
        <span className="dot" />
        <span className="dot" />
        <span className="dot" />
      </button>

      {/* dropdown */}
      {open && (
        <div className="kebab-menu" role="menu">
          <button className="menu-close" onClick={() => setOpen(false)}>
            ✕ {t("Close")}
          </button>

          {!assigning && isOwner ? (
            <>
              <button role="menuitem" onClick={() => handleOption(onEditClick)}>
                {t("Edit the card")}
              </button>

              <button role="menuitem" onClick={() => setAssigning(true)}>
                {t("Assign To collection")}
              </button>

              <button
                role="menuitem"
                onClick={() => handleOption(onMarkAsSoldClick)}
              >
                {t("Mark as Sold & Set Price")}
              </button>

              {isForSale && (
                <button
                  role="menuitem"
                  onClick={() => handleOption(onRemoveFromSellCards)}
                >
                  {t("Not For Sale")}
                </button>
              )}
              {isForTrade && (
                <button
                  role="menuitem"
                  onClick={() => handleOption(onRemoveFromTradeCards)}
                >
                  {t("Not For Trade")}
                </button>
              )}
              {isPC && (
                <button
                  role="menuitem"
                  onClick={() => handleOption(onRemoveFromPC)}
                >
                  {t("Not PC")}
                </button>
              )}
              {isOnEbay && (
                <button
                  role="menuitem"
                  onClick={() => handleOption(onRemoveFromEbay)}
                >
                  {t("Not On Ebay")}
                </button>
              )}

              {onMylisting &&
                onMylisting !== "" &&
                onMylisting !== "0" &&
                onMylisting !== "MyListings" && (
                  <button
                    role="menuitem"
                    onClick={() => handleOption(onRemoveFromWatchlistClick)}
                  >
                    {t("Remove from watchlist")} ({onMylisting})
                  </button>
                )}

              <button
                role="menuitem"
                className="danger"
                onClick={() => handleOption(onDeleteClick)}
              >
                {t("Delete the card")}
              </button>
            </>
          ) : (
            <>
              <button role="menuitem" onClick={() => setAssigning(false)}>
                {t("Cancel")}
              </button>
              {collectionList.map((c) => (
                <button
                  key={c.ListId}
                  role="menuitem"
                  onClick={() =>
                    handleOption(() => onAssignCollection(c.ListId, cardId))
                  }
                >
                  {`${t("Add to")} ${c.Title} (${c.collectionCount})`}
                </button>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default MoreOptionsButton;
